var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.728 1 10.016 5.98v5.128l1.044.57v1.613l-.807.286v2.196l.79.404.065.033V18.838l-.02.03-.834 1.202v2.196l-.663.427.854.475v2.753l-4.366 2.517-.57-.76v1.045L17.057 31l-5.981-3.323-1.614.76-3.418-1.852v-2.373L5 23.595v-1.52l.427-.379V6.981L15.727 1zm9.877 19.209-.006-.005.998-1.441v-1.41l-.617-.316v.054h-.141L15.632 22.74l-4.367-5.126v-3.275l-1.33-.808-.616.522v3.038l-.617 2.278v1.567l6.93 4.035.665-.238 2.373.238v-.238l.95.238.57-.76 1.234.522 1.234-1.993.38.238 1.14-1.52.237.428 1.19-1.677zm-2.14-3.118V15.81l-1.471 1.044V17.9l1.471-.808zm-4.13 2.278V17.9l1.33-.808-1.33-.807-1.281.807v2.99l1.281-.712z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoe);
export default __webpack_public_path__ + "static/media/JOE.f5b0b28ca79831a39fc321bb78412e5c.svg";
export { ForwardRef as ReactComponent };